import React from 'react';
import {
  FaArrowRight,
  FaBell,
  FaCalendarDay,
  FaClipboardList,
  FaClock,
  FaTimes
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

function SummaryRow({ icon: Icon, label, value }) {
  return (
    <div className="flex items-center justify-between rounded-lg bg-slate-50 px-4 py-3">
      <div className="flex items-center gap-3">
        <div className="rounded-full bg-red-100 p-2 text-red-600">
          <Icon className="text-sm" aria-hidden="true" />
        </div>
        <span className="text-sm font-medium text-slate-700">{label}</span>
      </div>
      <span className="text-lg font-bold text-slate-900">{value}</span>
    </div>
  );
}

const ModalAlertaCompromisosLogin = ({ isOpen, onClose, role, alert }) => {
  const navigate = useNavigate();

  if (!isOpen || !alert) {
    return null;
  }

  const isAdmin = role === 'admin';
  const destination = isAdmin ? '/admin/gestion-moras' : '/asesor/gestion-moras';
  const title = isAdmin ? 'Alertas de compromisos pendientes' : 'Tienes compromisos pendientes por revisar';
  const description = isAdmin
    ? 'Revisa los créditos sin compromiso registrado y los acuerdos cercanos a su fecha en Gestión de Moras.'
    : 'Revisa los créditos sin compromiso registrado y los acuerdos cercanos a su fecha en Gestión de Moras.';
  const proximidadLabel = alert.diasAlerta <= 1 ? 'Compromisos que vencen mañana' : 'Compromisos próximos';
  const resumenRows = [
    {
      icon: FaClipboardList,
      label: 'Créditos sin compromiso',
      value: alert.totales.sinCompromiso,
    },
    {
      icon: FaClock,
      label: 'Compromisos vencidos',
      value: alert.totales.compromisosVencidos,
    },
    {
      icon: FaCalendarDay,
      label: 'Compromisos que vencen hoy',
      value: alert.totales.compromisosVenceHoy,
    },
    {
      icon: FaBell,
      label: proximidadLabel,
      value: alert.totales.compromisosPorVencer,
    },
  ];

  const handleNavigate = () => {
    onClose();
    navigate(destination);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="w-full max-w-lg overflow-hidden rounded-xl bg-white shadow-2xl">
        <div className="relative rounded-t-xl bg-gradient-to-r from-red-500 to-orange-500 p-6">
          <button
            type="button"
            onClick={onClose}
            className="absolute right-4 top-4 text-white transition hover:text-gray-200"
            aria-label="Cerrar modal"
          >
            <FaTimes />
          </button>

          <div className="flex flex-col items-center text-center">
            <div className="mb-4 rounded-full bg-white p-4">
              <FaClipboardList className="text-4xl text-red-500" aria-hidden="true" />
            </div>
            <h2 className="text-2xl font-bold text-white">{title}</h2>
          </div>
        </div>

        <div className="p-6">
          <div className="mb-6">
            <p className="text-center text-gray-700">{description}</p>
          </div>

          <div className="mb-6 space-y-3">
            {resumenRows.map((item) => (
              <SummaryRow
                key={item.label}
                icon={item.icon}
                label={item.label}
                value={item.value}
              />
            ))}
          </div>

          <div className="flex flex-col gap-3 sm:flex-row">
            <button
              type="button"
              onClick={handleNavigate}
              className="flex flex-1 items-center justify-center gap-2 rounded-lg bg-red-600 px-5 py-3 text-sm font-semibold text-white transition hover:bg-red-700"
            >
              Ir a Gestión de Moras
              <FaArrowRight className="text-xs" />
            </button>
            <button
              type="button"
              onClick={onClose}
              className="flex-1 rounded-lg bg-gray-200 px-5 py-3 text-sm font-semibold text-gray-700 transition hover:bg-gray-300"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalAlertaCompromisosLogin;
